import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BASE_URL, USER_URL } from '../../constant/api';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AddEditOrganization() {
  const [organizationInfo, setOrganizationInfo] = useState({
    name: '',
    license_number: '',
    bank_name: '',
    account_number: '',
    ifsc: '',
    tax_number: '',
    address: '',
    location: '',
  });

  const [isLoading, setIsLoading] = useState(true);
  const [isNew, setIsNew] = useState(false); // Track if it's a new organization

  const fetchOrganizationInfo = async () => {
    try {
      const response = await USER_URL.get(`/accounts/organization/`);
      const data = response.data?.data?.[0] || {};

      if (Object.keys(data).length === 0) {
        setIsNew(true); // If no data, it's a new organization
      } else {
        setOrganizationInfo({
          name: data.name || '',
          license_number: data.license_number || '',
          bank_name: data.bank_name || '',
          account_number: data.account_number || '',
          ifsc: data.ifsc || '',
          tax_number: data.tax_number || '',
          address: data.address || '',
          location: data.location || '',
        });
        setIsNew(false);
      }
    } catch (error) {
      console.error('Error fetching organization info:', error);
      setIsNew(true); // Assume it's new if an error occurs
    } finally {
      setIsLoading(false);
    }
  };

  const handleOrganizationChange = (e) => {
    const { name, value } = e.target;
    setOrganizationInfo({ ...organizationInfo, [name]: value });
  };

  const saveOrganizationDetails = async (event) => {
    event.preventDefault();
    // const token = localStorage.getItem("token");
    // const headers = { Authorization: `Token ${token}` };

    try {
      if (isNew) {
        // Create new organization
        await USER_URL.post(`/accounts/organization/`, organizationInfo, );
         toast.success("Organization added successfully!");
      } else {
        // Update existing organization
        await USER_URL.patch(`/accounts/organization/`, organizationInfo, );
         toast.success("Organization details updated successfully!");
      }
      fetchOrganizationInfo(); // Refresh data after save
    } catch (error) {
      toast.error("Failed to save organization details");
      console.log("Error saving organization details:", error);
    }
  };

  useEffect(() => {
    fetchOrganizationInfo();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-10 mt-5">
    <ToastContainer position="top-center" autoClose={2000} />
      <h1 className="text-2xl font-bold text-green-600">
        {isNew ? "Add Organization" : "Edit Organization"}
      </h1>

      <form className="w-full my-6" onSubmit={saveOrganizationDetails}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col">
            <label className="text-sm font-semibold">Organization Name</label>
            <input
              type="text"
              name="name"
              placeholder="Organization Name"
              value={organizationInfo.name}
              onChange={handleOrganizationChange}
              className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
              required
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-semibold">License Number</label>
            <input
              type="text"
              name="license_number"
              placeholder="License Number"
              value={organizationInfo.license_number}
              onChange={handleOrganizationChange}
              className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
              required
            />
          </div>
        </div>
        <div className="mt-6 flex flex-col">
          <label className="text-sm font-semibold">Address</label>
          <textarea
            name="address"
            placeholder="Address"
            value={organizationInfo.address}
            onChange={handleOrganizationChange}
            className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <div className="flex flex-col">
            <label className="text-sm font-semibold">Bank Name</label>
            <input
              type="text"
              name="bank_name"
              placeholder="Bank Name"
              value={organizationInfo.bank_name}
              onChange={handleOrganizationChange}
              className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
              required
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-semibold">Account Number</label>
            <input
              type="text"
              name="account_number"
              placeholder="Account Number"
              value={organizationInfo.account_number}
              onChange={handleOrganizationChange}
              className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
              required
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-semibold">IFSC Code</label>
            <input
              type="text"
              name="ifsc"
              placeholder="IFSC Code"
              value={organizationInfo.ifsc}
              onChange={handleOrganizationChange}
              className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
              required
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-semibold">Tax Number</label>
            <input
              type="text"
              name="tax_number"
              placeholder="Tax Number"
              value={organizationInfo.tax_number}
              onChange={handleOrganizationChange}
              className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
              required
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-semibold">Location</label>
            <input
              type="text"
              name="location"
              placeholder="Location"
              value={organizationInfo.location}
              onChange={handleOrganizationChange}
              className="border border-gray-300 p-3 rounded-lg w-full focus:ring-2 focus:ring-green-400"
              required
            />
          </div>
          <button
          type="submit"
          className="w-full bg-green-600 text-white p-3 rounded-lg hover:bg-green-700 transition mt-5"
        >
          {isNew ? "Add Organization" : "Save Changes"}
        </button>
        </div>

       
      </form>
    </div>
  );
}

export default AddEditOrganization;

